export function dndAnnouncements(t) {
  return {
    onDragStart({ active }) {
      return t('a11y.dragStart', { item: String(active?.id || '') });
    },
    onDragOver({ active, over }) {
      if (!over) {
        return t('a11y.dragOverNone', { item: String(active?.id || '') });
      }
      return t('a11y.dragOver', { item: String(active?.id || ''), over: String(over.id) });
    },
    onDragEnd({ active, over }) {
      if (!over) {
        return t('a11y.dragCancel', { item: String(active?.id || '') });
      }
      return t('a11y.dragEnd', { item: String(active?.id || ''), over: String(over.id) });
    },
    onDragCancel({ active }) {
      return t('a11y.dragCancel', { item: String(active?.id || '') });
    },
  };
}
